export default __webpack_public_path__ + "static/media/circle-o-plus-small-blue.efd3fcba.svg";